import { Component, OnInit, Inject } from '@angular/core';
import { Acuerdo } from '../acuerdo.model';
import { Observer } from '../../../../node_modules/rxjs/Observer';
import { Observable } from '../../../../node_modules/rxjs/Observable';
import { EnvironmentProvider } from '../../core/browser-providers';
import { Environment } from '../../../environments/enviroment.model';
import { ActivatedRoute, Router } from '../../../../node_modules/@angular/router';
import { BackendService } from '../../core/backend.service';
import { MatPaginatorIntl } from '../../../../node_modules/@angular/material';
import { SecurityService } from '../../security/security.service';
import { SnackService } from '../../shared-services/snack.service';
import { ProductoCantidadTotal } from './producto-cantidad-total.model';

@Component({
  selector: 'app-ver-productos-pedidos',
  templateUrl: './ver-productos-pedidos.component.html',
  styleUrls: ['./ver-productos-pedidos.component.scss']
})
export class VerProductosPedidosComponent implements OnInit {

  acuerdo: Acuerdo;
  productoCantidadTotal: ProductoCantidadTotal[];

  isLoading = false;
  totalItems = 0;

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    public router: Router,
    public securityService: SecurityService,
    private snackService: SnackService,
  ) { }

  async ngOnInit() {
    this.route.data.subscribe(data => {
      this.acuerdo = data.acuerdo;
    });

    await this.getCantidadComprada();
  }

  back() {
    this.router.navigate(['/acuerdos' + this.acuerdo.id]);
  }

  async getCantidadComprada() {
    this.isLoading = true;
    await this.backendService.getBoolean(Acuerdo.path + 'cant-total-prod/' + this.acuerdo.id).then(
      value => {
        this.productoCantidadTotal = value as ProductoCantidadTotal[];
        this.isLoading = false;
        this.totalItems = this.productoCantidadTotal.length;
      });
  }

  onPageChange(page) { }

}



// WEBPACK FOOTER //
// ./src/app/acuerdo/ver-productos-pedidos/ver-productos-pedidos.component.ts